<template>
  <div>
    <div class="black-overlay"></div>
    <div :class="['modal', 'modal--postgame', (getGameDescriptionDetails.home && getGameDescriptionDetails.roundDtos[0].isWinner) ||
           (!getGameDescriptionDetails.home && !getGameDescriptionDetails.roundDtos[0].isWinner) ? 'player1' : 'player2']" id="welcome_modal">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header">
          <h1 v-if="(getGameDescriptionDetails.roundDtos[0].isWinner)">
            {{ getTranslations.home_modals_score_description_congratz
            }}<br>{{ getTranslations.home_modals_score_description_you_won_the_game }}</h1>
          <h1 v-else>{{ getTranslations.home_modals_score_description_too_bad
            }}<br>{{ getTranslations.home_modals_score_description_you_lost_the_game }}</h1>
          <ul>
            <li v-if="getGameDescriptionDetails.home" :class="getGameDescriptionDetails.roundDtos[0].isWinner? 'post_winner':'post_loser'">
              <img :src="userDetails.avatar" alt="">
              <span class="name">{{ userDetails.username }}</span>
            </li>
            <li v-else :class="getGameDescriptionDetails.roundDtos[0].isWinner ?  'post_loser':'post_winner' ">
              <img :src="getOpponentDetails.avatar" alt="">
              <span class="name">{{ getOpponentDetails.opponentName }}</span>
            </li>
            <li class="trophy">
              <img src="static/images/trophy.png" alt="" :class="getGameDescriptionDetails.roundDtos[0].isWinner ?'':'lost_trophy'">
              <div :class="['score', getGameDescriptionDetails.roundDtos[0].isWinner ? 'post_score_win': 'post_score_lost' ]"><span>{{ getGameDescriptionDetails.homeScore
                }}</span>-<span>{{ getGameDescriptionDetails.awayScore }}</span></div>
            </li>
            <li v-if="getGameDescriptionDetails.home" :class="getGameDescriptionDetails.roundDtos[0].isWinner ? 'post_loser':'post_winner'">
              <img :src="getOpponentDetails.avatar" alt="">
              <span class="name">{{ getOpponentDetails.opponentName }}</span>
            </li>
            <li v-else :class="getGameDescriptionDetails.roundDtos[0].isWinner ? 'post_winner':'post_loser'">
              <img :src="userDetails.avatar" alt="">
              <span class="name">{{ userDetails.username }}</span>
            </li>
          </ul>
        </div>
        <div class="modal__body bottom-padding">

          <h3 v-if="getGameDescriptionDetails.roundDtos[0].isWinner && getGameDescriptionDetails.homeScore === getGameDescriptionDetails.awayScore">
            {{ getTranslations.home_round_ended_you_were_faster }}</h3>
          <h3 v-if="!getGameDescriptionDetails.roundDtos[0].isWinner && getGameDescriptionDetails.homeScore === getGameDescriptionDetails.awayScore">
            {{ getTranslations.home_round_ended_you_were_slower }}</h3>
          <h3>{{ getTranslations.home_modals_score_description_points_earned }}</h3>
          <ul class="buttons">
            <li><span class="score-lbl" style="background: #252525; border:2px solid #9c3123">{{ getGameDescriptionDetails.questionPoints }}</span><span
              class="title">{{ getTranslations.home_modals_score_description_correct_answers }}</span></li>
            <li><span class="score-lbl" style="background: #252525; border:2px solid #01621b">{{ getGameDescriptionDetails.gamePoints
              }}</span><span class="title">{{ getTranslations.home_modals_score_description_game_victory }}</span></li>
            <li><span class="score-lbl" style="background: #252525; border:2px solid #ffe200">{{ getGameDescriptionDetails.totalPoints
              }}</span><span class="title">{{ getTranslations.home_modals_score_description_total_earned }}</span></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'score-description',
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('profile', [
      'getGameDescriptionDetails',
      'getOpponentDetails',
    ]),
    roundDetails() {
      return this.getGameDescriptionDetails.roundDtos;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ScoreDescription.vue